import { useEffect, useState } from "react";
import { Receipt } from "lucide-react";
import { api, fmtDate, fmtDateTime, rupiah } from "../lib/api";

const CARD = "rounded-2xl border border-white/[0.08] bg-white/[0.03] backdrop-blur-sm";

export function PortalHistory({ secret, refreshKey }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { if (secret) api.get(`/portal/history/${encodeURIComponent(secret)}`).then((r) => setRows(r.data)).catch(() => setRows([])); }, [secret, refreshKey]);
  if (!rows) return null;
  return (
    <div className={`${CARD} fn-card`} data-testid="portal-history">
      <div className="px-5 py-3.5 border-b border-white/[0.06] flex items-center gap-2 font-bold text-white"><Receipt className="w-4 h-4 text-teal-300" /> Riwayat Pembayaran</div>
      {!rows.length ? <div className="px-5 py-4 text-sm text-slate-400" data-testid="portal-history-empty">Belum ada pembayaran tercatat.</div> : (
        <div className="divide-y divide-white/[0.06]">
          {rows.map((r) => (
            <div key={r.id} className="px-5 py-2.5 flex items-center justify-between gap-3 text-sm" data-testid={`portal-history-row-${r.id}`}>
              <div className="min-w-0">
                <div className="font-mono text-[12px] text-slate-300">{fmtDateTime(r.paid_at)}</div>
                <div className="text-[11px] text-slate-500">via {r.via}{r.expired_date && <> • aktif s/d <span className="font-mono text-teal-300">{fmtDate(r.expired_date)}</span></>}</div>
              </div>
              <div className="font-mono font-bold text-emerald-400 shrink-0">{rupiah(r.amount)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
